import request from '@/utils/axios'

//获取大类
export function getAllTypes(form) {
    return request({
        url: '/product/get_product_category',
        method: 'get',
        data: form
    })
}

// 获取产品品牌
export function getProductSpu(form) {
    return request({
        url: '/product/get_product_spu',
        method: 'get',
        params: form
    })
}

//获取省份
export function getAllProvince(form) {
    return request({
        url: '/product/get_province_by_spu',
        method: 'post',
        params: form
    })
}

//获取面值
export function getAllAmount(form) {
    return request({
        url: '/speed_up/get_amount_by_params',
        method: 'post',
        params: form
    })
}

//获取卡列表信息
export function getCardDetail(form) {
    return request({
        url: '/product/product',
        method: 'get',
        params: form
    })
}

//获取每一张卡的详情信息
export function getOneCardDetailInfo(form) {
    return request({
        url: '/product/product_detail',
        method: 'get',
        params: form
    })
}

//提交卡回收
export function submitRecycle(form, postUrl) {
    return request({
        url: postUrl,
        method: 'post',
        data: form
    })
}



// WEBPACK FOOTER //
// ./src/api/recycle.js